import type { FormHotkeyBarItem } from '../components/FormHotkeyBar';
import type { FormHotkeyId, FormHotkeyMap } from '../hooks/useFormHotkeys';

export interface FormHotkeyBarDefinition {
  id: FormHotkeyId;
  caption: string;
  tooltip: string;
  variant?: FormHotkeyBarItem['variant'];
}

export function buildFormHotkeyBarItems(
  hotkeys: FormHotkeyMap,
  definitions: FormHotkeyBarDefinition[],
  overrides?: Partial<
    Record<
      FormHotkeyId,
      Partial<Pick<FormHotkeyBarItem, 'label' | 'tooltip' | 'disabled'>>
    >
  >,
): FormHotkeyBarItem[] {
  return definitions.map((def) => {
    const action = hotkeys[def.id];
    const override = overrides?.[def.id];
    const keyLabel = def.id === 'Escape' ? 'ESC' : def.id;
    return {
      id: def.id,
      label: override?.label ?? `${keyLabel}-${def.caption}`,
      tooltip: override?.tooltip ?? def.tooltip,
      onClick: () => action?.handler(),
      disabled: override?.disabled ?? (action?.enabled === false || !action),
      variant: def.variant ?? 'default',
    };
  });
}
